import Vue from "vue";
import Vuex from "vuex";
import pessoa from "@/store/pessoa";
import pet from "@/store/pet";
import tag from "@/store/tag";
import tagFuncionario from "@/store/tag-funcionario";
import cliente from "@/store/cliente";
import auth from "@/store/auth";
import VuexPersistence from "vuex-persist";

const vuexLocal = new VuexPersistence({
  storage: window.sessionStorage,
});

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    language: "",
    attachmentDocumentURL:
      "https://mylifeclick-download-files.s3.amazonaws.com/attachmentDocument/",
    vaccineDocumentsURL:
      "https://mylifeclick-download-files.s3.amazonaws.com/vaccineDocuments/",
    healthInsuranceDocumentsURL:
      "https://mylifeclick-download-files.s3.amazonaws.com/healthInsuranceDocuments/",
    donorDocumentsURL:
      "https://mylifeclick-download-files.s3.amazonaws.com/donorDocuments/",
    medicalDocumentsURL:
      "https://mylifeclick-download-files.s3.amazonaws.com/medicalDocuments/",
    profileImageURL:
      "https://mylifeclick-download-files.s3.amazonaws.com/profileImage/",
    statusLoadTranslate: "",
    showModalDataForm: false,
    selectedRestrictFields: "",
    context: undefined,
    hideNoFilled: false,
    allFilled: false,
    imgLogoDefault: "/img/my-life-click-logo.jpeg",
    snackbarLoading: {
      status: false,
      message: "",
    },
    snackbarSuccess: {
      status: false,
      message: "",
    },
    snackbarError: {
      status: false,
      message: "",
    },
    register: {
      idioma: "",
      email: "",
      celular: "",
      password: "",
    },
    languages: [
      { lang: "português", flag: "pt_br" },
      { lang: "italiano", flag: "it" },
      { lang: "español", flag: "es" },
      { lang: "english", flag: "en" },
    ],
  },
  mutations: {
    setStatusLoadTranslate(state, payload) {
      state.statusLoadTranslate = payload;
    },
    setLanguage(state, payload) {
      state.language = payload;
    },
    setShowModalDataForm(state, payload) {
      state.showModalDataForm = payload;
    },
    setSelectedRestrictFields(state, payload) {
      state.selectedRestrictFields = payload;
    },
    setContext(state, payload) {
      state.context = payload;
    },
    setHideNoFilled(state, payload) {
      state.hideNoFilled = payload;
    },
    setAllFilled(state, payload) {
      state.allFilled = payload;
    },
    setSnackbarLoading(state, { status, message }) {
      state.snackbarLoading.status = status;
      state.snackbarLoading.message = message;
    },
    setSnackbarSuccess(state, { status, message }) {
      state.snackbarSuccess.status = status;
      state.snackbarSuccess.message = message;
    },
    setSnackbarError(state, { status, message }) {
      state.snackbarError.status = status;
      state.snackbarError.message = message;
    },
  },
  actions: {},
  modules: {
    pessoa,
    pet,
    tag,
    tagFuncionario,
    cliente,
    auth,
  },
  plugins: [vuexLocal.plugin],
});
